import jobRoles from './job-roles.json';

export const getJobRoleFromSlug = (slug?: string): string => {
  const rolesToExclude = ['manager'];
  let jobRole = '';

  jobRoles.roles.forEach((role) => {
    if (slug?.includes(role) && !rolesToExclude.includes(role)) {
      jobRole = role;
    }
  });

  return jobRole;
};
